module.exports = __webpack_public_path__ + "static/media/img2.3f384bbb.png";